import { ITradeCaptureReport } from "@pulse-ui/codegen/generated_ts/drop_copy";
import { IAGTradeEventDataRow } from "../../../AlgoTable.types";
import { v4 as uuidv4 } from "uuid";
import { capitalizeFirstChars } from "@pulse-ui/formatting";

export const mapTradeEvent = (rpt: ITradeCaptureReport): IAGTradeEventDataRow => {
    return {
        row_id: uuidv4(),
        order_id: rpt?.order_id ?? "-",
        trade_id: rpt?.trade_id ?? "-",
        exec_type: capitalizeFirstChars(rpt.exec_type?.toString().split("_")) ?? "-",
        symbol: rpt?.symbol ?? "-",
        last_qty: rpt?.last_qty?.toString() ?? "-",
        last_px: rpt?.last_px?.toString() ?? "-",
        contract_size: rpt?.contract_size?.toString() ?? "-",
        side: rpt?.side?.toString() ?? "-",
        transact_time: rpt?.transact_time ?? "-",
        venue: rpt?.venue ?? "-",
    };
}